export default[
  {
    path: '/dataList/attendanceStatistics',
    component: resolve => require(['../page.vue'], resolve),
    meta: {
        title: '打卡统计',
        authLogin: true
    }
  },
  {
    path: '/dataList/attendanceDetail',
    component: resolve => require(['../detail.vue'], resolve),
    meta: {
        title: '打卡明细',
        authLogin: true
    }
  },
]